'use strict';
import { ChangeDetectionStrategy, Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { IdynamicFormItem } from '@ispm/dynamic-form/interfaces/IdynamicFormItem';
import { IWidgetItem } from '@ispm/widgets/interfaces/widget-item.interface';
import { Widget } from '../../../../../../../modules/widgets/decorator/widget.decorator';;
import { DynamicModalLoaderService} from '@ispm/layout/services/dynamic-modal-loader.service';
import { ModalTypes } from '@ispm/layout/components/modals/contants/modal-types.enum';
import { PlaceholderModalComponent } from '@ispm/layout/components/modals/placeholder-modal/placeholder-modal.component';
import { PlaceholderModalLoaderPayload } from '@ispm/layout/classes/placeholder-modal-loader-payload';
import { Subscription } from 'rxjs';
import {AddRichNotesComponent} from "../../../../../../notes/components/add-rich-notes.component/add-rich-notes.component";

@Component({
  selector: 'ispm-pathways-treatment-plan-notes',
  templateUrl: './treatment-plan-notes.component.html',
  styleUrls: ['./treatment-plan-notes.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

@Widget('TreatmentPlanNotes')
export class TreatmentPlanRichNotesWidgetComponent implements OnInit, IWidgetItem, OnDestroy {
  public universalNotesData:string = '';
  public oldUniversalNotesData:string = '';
  private modalSubscription$: Subscription;
  public isFormDisabled = true;
  public isNoteChanged = false;

  constructor(private _changeDetector: ChangeDetectorRef,
              private modalLoader: DynamicModalLoaderService) {};

  ngOnInit(): void {}

  set widgetData(widgetData: any) {
    if (widgetData && widgetData.value) {
      if (this.universalNotesData !== widgetData.value)
        this.universalNotesData = widgetData.value;
    } else {
      if (this.universalNotesData !== widgetData)
        this.universalNotesData = widgetData;
    }
  }

  set widgetConfig(widgetConfig: IdynamicFormItem) {
    this.isFormDisabled = widgetConfig.widgetPayload.disabled;
  }

  set widgetFormInstanceSubmitted(widgetFormInstanceSubmitted: boolean) {
    if (widgetFormInstanceSubmitted) {
      if (this.oldUniversalNotesData == this.universalNotesData){
        this.isNoteChanged = false;
      }
      this._changeDetector.markForCheck();
    }
  }

  widgetUpdateValueCallback: (value) => void;

  onTreatmentPlanNotesClick($event) {
    if (this.isFormDisabled) {
      $event.stopPropagation();
      return;
    }
    this.oldUniversalNotesData = this.universalNotesData;
    this.modalSubscription$ = this.modalLoader.popupModal(PlaceholderModalComponent,
        new PlaceholderModalLoaderPayload(
          "Universal Treatment Plan notes",
          AddRichNotesComponent,
          'Save', // 'Save changes',
          'Cancel', // 'Cancel',
          {
            notes: this.universalNotesData,
          },
        ), ModalTypes.NONE, 'TREATMENT_PLAN_NOTES_POPUP')
        .subscribe(res => {
          if (res.payload.status === 1) {
            this.widgetUpdateValueCallback(res.payload.payload.value);
            this.universalNotesData = res.payload.payload.value;
            if (this.oldUniversalNotesData != res.payload.payload.value) {
              this.isNoteChanged = true;
            }
          }
          this._changeDetector.detectChanges();
    });
  }

  ngOnDestroy(): void {
    this.modalSubscription$?.unsubscribe();
  }

}
